import { StatusBar } from 'expo-status-bar'
import { useEffect } from 'react'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import CameraStack from './CameraStack'
import TabNavigator from './TabNavigator'

const Stack = createNativeStackNavigator()

// components
import { Loading } from '../components/shared/navigator/Loading'

// stores
import { useInitializeStore } from '../stores/initialize'
import { useAuthStore } from '../stores/auth'
import { View } from 'react-native'
import Loginerror from '../screens/home/loginerror/Loginerror'
import AsyncStorage from '@react-native-async-storage/async-storage'

const AppStack = (): JSX.Element => {
  // stores' data
  const { initializeData, loading, error, errorCode, initialize } =
    useInitializeStore()
  const { logout } = useAuthStore()

  // useEffect(() => {
  //   const getStoreId = async () => {
  //     return await AsyncStorage.getItem('essUserKey')
  //   }
  //   const storeId = getStoreId()

  //   console.log("storeid", storeId)


  //   initialize(null)

  //   // if (errorCode === 'invalid_grant') {
  //   // if (errorCode) {
  //   //   logout()
  //   // }
  // }, [errorCode])

  useEffect(() => {
    const initializeStoreId = async () => {
      try {
        const storeId = JSON.parse(await AsyncStorage.getItem('storeId'));
        initialize(storeId);
      } catch (error) {
        console.error("Failed to retrieve store ID:", error);
      }
    };

    initializeStoreId();

    // if (errorCode === 'invalid_grant') {
    // if (errorCode) {
    //   logout();
    // }
  }, [errorCode]);

  if (loading) return <Loading />

  return (
    <>
      {initializeData && !errorCode ? (
        <>
          <Stack.Navigator
            initialRouteName="HomeNavigator"
            screenOptions={{
              headerShown: false,
              animation: 'fade_from_bottom'
            }}
          >
            <Stack.Screen
              options={{ headerShown: false }}
              name="HomeNavigator"
              component={TabNavigator}
              initialParams={{ ...initializeData }}
            />
            <Stack.Screen
              options={{ headerShown: false }}
              name="CameraStack"
              component={CameraStack}
              initialParams={{ ...initializeData }}
            />
          </Stack.Navigator>
          <StatusBar style="light" />
        </>
      ) : (
        <Stack.Navigator>
          <Stack.Screen
            options={{ headerShown: false }}
            name="Login Error"
            component={Loginerror}
            initialParams={{ ...initializeData }}
          />
        </Stack.Navigator>
      )}
    </>
  )
}

export default AppStack
